import React, {FC} from 'react';
import styled from 'styled-components';

import {Dropdown, DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {TagEditorBody, TagEditorBodyProps} from './tagEditorBody';

/*
 * Constants.
 */

const tagCreationErrorHeight = 20;

/*
 * Props.
 */

export interface TagEditorDropdownProps extends TagEditorBodyProps, DropdownProps {}

/*
 * Style.
 */

const StyledDropdown = styled(Dropdown)`
  border-radius: 16px;
`;

/*
 * Component.
 */

export const TagEditorDropdown: FC<TagEditorDropdownProps> = (props) => (
  <StyledDropdown
    anchor={props.anchor}
    onRequestClose={props.onRequestClose}
    width={300}
    height={props.height && (props.tagError ? props.height + tagCreationErrorHeight : props.height)}
    hasBackground
    shouldUntether={props.shouldUntether}
    placement={props.placement}
  >
    <TagEditorBody
      userId={props.userId}
      teammates={props.teammates}
      title={props.title}
      tagId={props.tagId}
      renderExtraDropdownItems={props.renderExtraDropdownItems}
      resourceNamespace={props.resourceNamespace}
      okButtonLabel={props.okButtonLabel}
      onOkClick={props.onOkClick}
      isEditing={props.isEditing}
      isSystemTag={props.isSystemTag}
      initialState={props.initialState}
      hasPermission={props.hasPermission}
      onRequestClose={props.onRequestClose}
      shouldHideNamespaceSelector={props.shouldHideNamespaceSelector}
      shouldHideParentTagSelector={props.shouldHideParentTagSelector}
      isSaving={props.isSaving}
      tagError={props.tagError}
      shouldHideShowInWorkspace={props.shouldHideShowInWorkspace}
      hasPreventPinTeamTags={props.hasPreventPinTeamTags}
      canCreateCompanyTags={props.canCreateCompanyTags}
    />
  </StyledDropdown>
);
